import { ListItem } from '../types';

export function clearSelected(list: Array<ListItem>) {
	return list.map(item => {
		return { ...item, selected: false };
	});
}
